<template>
  <div style="min-height:200px">
    <div
      v-if="index == 0 && user && !imagesSceleton"
      style="position:absolute; left:-224px; width:200px;"
    >
      <input ref="fileInput" style="display:none" type="file" @change="createItem">
      <v-hover>
        <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`"
          style="background-color:rgba(0,0,0,0);border-radius:4px;user-select: none;cursor:pointer"
          @click="loading?null:$refs.fileInput.click()"
        >
          <div
            v-if="!loading"
            style="display:flex;justify-content:center;align-items:center;height:200px; width:100%;background-color:rgba(0,0,0,0.4)"
          >
            <v-icon x-large dark>add</v-icon>
          </div>
          <div
            v-else
            style="display:flex;justify-content:center;flex-direction:column;align-items:center;height:200px; width:100%;background-color:rgba(0,0,0,0.4)"
          >
            <v-progress-circular indeterminate color="white"></v-progress-circular>
          </div>
        </v-card>
      </v-hover>
    </div>
    <div v-if="imagesSceleton" style="height:200px;margin-top:-14px">
      <v-progress-linear
        height="200"
        style="border-radius:4px;opacity:0.4; width:200px"
        :indeterminate="true"
      ></v-progress-linear>
    </div>
    <v-hover v-if="!imagesSceleton">
      <v-card
        slot-scope="{ hover }"
        style="background-color:rgba(0,0,0,0);border-radius:4px;"
        :class="[`elevation-${hover ? 12 : 0}`, {'white':hover}]"
        @click="dialogItem = {active: true, item: item, category: category }"
      >
        <v-img
          v-if="item.thumbnailUrl"
          style="border-radius:4px;"
          :class="[`elevation-${!hover ? 2 : 0}`,`rotate-${item.rotate}`,{'border-radius':hover && type!='horizontalSwiper' && item.title}]"
          :src="item.thumbnailUrl"
          :lazy-src="item.thumbnailUrl"
          class="grey lighten-2"
          aspect-ratio="1"
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <div v-else-if="item.date" style="height:200px;margin-top:-14px">
          <v-progress-linear
            height="200"
            style="border-radius:4px;opacity:0.4; width:200px"
            :indeterminate="true"
          ></v-progress-linear>
        </div>
        <v-card-title v-if="type!='horizontalSwiper' && item.title">
          <div
            class="item-title"
            :class="{'text-truncate':!hover, 'text-margin': !hover}"
          >{{ item.title }}</div>
        </v-card-title>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from "../firebaseConfig.js";

export default {
  name: "Item",
  props: ["item", "type", "index", "category"],
  computed: {
    ...mapState(["user", "imagesSceleton", "loading"]),
    dialogItem: {
      get: function() {
        return this.$store.state.dialogItem;
      },
      set: function(newValue) {
        this.$store.commit("setDialogItem", newValue);
      }
    }
  },
  methods: {
    createItem(event) {
      let data = {
        event: event,
        category: this.category
      };
      this.$store.dispatch("createItem", data);
    }
  }
};
</script>

<style scoped>
.border-radius {
  border-radius: 4px 4px 0px 0px !important;
}
.item-title {
  /* font-family: secondary; */
  font-size: 20px;
  transition: all 0.2s;
  padding-bottom: 2px;
}
.text-margin {
  margin-left: -15px;
}
/* .v-image__image .v-image__image--cover{
  transform: rotate(45deg);
} */
</style>
